<template>
  <!-- CSS命名参考BEM规范 -->
  <div class="navAllPanel"
       :style="{marginLeft: marginLeft + 'px'}"
       @mouseover.stop="keepStatus()">
    <div class="navAllPanel__center">
      <div class="close__panel" @click="closePanel()"></div>
      <div class="panel__search">
        <el-input placeholder="请输入内容"
                  prefix-icon="el-icon-search"
                  v-model="keywords"
                  :result="navTopMenu"
                  style="max-width: 500px">
        </el-input>
        </div>
      <div class="navAllPanel__col" v-for="(cols,index) in navTopMenu" :key="index">
        <div class="navAllPanel__item" v-for="(col,index) in cols" :key="index">
          <div class="navAllPanel__title" v-text="col.name"></div>
          <div class="navAllPanel__product"
               v-for="(item,index) in col.children"
               :key="index"
               @click="onGoToUrl(item)"
               @mouseover="showSelect(item.id)"
               @mouseleave="clearSelect()">
            {{item.name}}
            <div v-if="checkList.includes(item.href)"
                 class="select product__selected"
                 @click.stop="removePro(item.href)"
            ></div>
            <div v-if="!checkList.includes(item.href) && isHoverId === item.id"
                 class="select product__select"
                 @click.stop="selectPro(item.href)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from '../../utils/tools';
import mutationTypes from '../../store/mutation-types';
import actionTypes from '../../store/action-types';
import consolePanelReq from '../../assets/js/request/otherService/consolePanelReq';

export default {
    data(){
        return{
            keywords: '',
            menu: [],
            checkList: [],
            isHoverId: ''
        }
    },
    props: {
      marginLeft: {
          type: Number,
          default: 0
      },
      deleteHref: {
          type: String,
          default: ''
      }
    },
  computed: {
    navTopMenu: function () {
      let navTopMenu = this.$store.state.navTopMenu;
      let newNavTopMenu = [];
      if (navTopMenu.length) {
          for(let i = 0; i < navTopMenu.length; i ++) {
              let list = navTopMenu[i].children.filter( value => value.name.indexOf( this.keywords ) > -1);
              if(list.length){
                newNavTopMenu.push({
                    name: navTopMenu[i].name,
                    col: navTopMenu[i].col,
                    icon: navTopMenu[i].icon,
                    parentId: navTopMenu[i].parentId,
                    id: navTopMenu[i].id,
                    children: list
                })
              }
          }
      }
        let formatNavTopMenu = groupBy(newNavTopMenu, (item) => {
            return item.col;
        });
      return formatNavTopMenu;
    }
  },
  watch: {
    deleteHref(val) {
        this.checkList.splice(this.checkList.indexOf(this.deleteHref), 1)
    }
  },
  methods: {
    onGoToUrl(item) {
      let url = item.href.indexOf('sku') > -1 ? item.href + '&name=' + item.name : item.href;
      this.$emit('hiddenNavAllPanel');
      window.location.href = url;
    },
    keepStatus() {
      this.$emit("keepStatus")
    },
    closePanel() {
      this.$emit("closePanel")
    },
    showSelect(id) {
      this.isHoverId = id
    },
    clearSelect() {
      this.isHoverId = ''
    },
    removePro(href) {
        this.checkList.splice(this.checkList.indexOf(href), 1);
        let bb = [];
        let newList = [];
        if (this.checkList.length !== 0) {
            let list = this.$store.state.navTopMenu.reduce((sum, item) => {
                return sum.concat(item.children);
            }, []);
            bb = this.checkList.map(item => {
                return list.find(o => o.href === item);
            });
            if (bb.length) {
              for(let i = 0; i < bb.length; i ++) {
                newList.push({
                  name: bb[i].name,
                  href: bb[i].href,
                  icon: bb[i].icon,
                })
              }
            }
        }
        
        this.$store.dispatch(actionTypes.UPDATE_NAV_LEFT_MEUN, newList);
        //this.$store.commit(mutationTypes.SET_NAV_LEFT_MENU, newList);
    },
    selectPro(href) {
        if (this.checkList.length >= 8) {
            this.$notify.warning({
                title: '提示',
                message: '最多可选择8个列表项'
            })
        } else {
            this.checkList.push(href);
            let list = this.$store.state.navTopMenu.reduce((sum, item) => {
                return sum.concat(item.children);
            }, []);
            let aa = this.checkList.map(item => {
                return list.find(o => o.href === item);
            });
            let newList = [];
            if (aa.length) {
              for(let i = 0; i < aa.length; i ++) {
                if (aa[i]) {
                  newList.push({
                    name: aa[i].name,
                    href: aa[i].href,
                    icon: aa[i].icon,
                  })
                }
              }
            }
            this.$store.dispatch(actionTypes.UPDATE_NAV_LEFT_MEUN, newList);
            //this.$store.commit(mutationTypes.SET_NAV_LEFT_MENU, newList);
            // console.log(this.$store.state.navLeftMenu)
        }
    }
  },
   created() {
       this.keywords = '';
       let sideBarMenu = JSON.parse(sessionStorage.getItem("navLeftMenu")) || [];
       this.checkList = sideBarMenu.map(item => item.href);
   }
}
</script>

<style>
@media screen and (max-width: 1200px) {
  .navAllPanel__center {
    margin: 0 0 0 70px;
  }
}

.navAllPanel {
  position: fixed;
  top: 50px;
  bottom: 0px;
  overflow-y: auto;
  background-color: #171921;
  z-index: -1;
  font-size: 14px;
}

.navAllPanel__center {
  padding: 0 10px;
  background-color: #171921;
  overflow-x: hidden;
  overflow-y: auto;
}

.panel__search {
  margin: 39px 47px 39px 35px;
  height: 20px;
}

.panel__search .el-input input{
  background-color: transparent;
  border-color: #383940;
  color: #D6D8D9;
}

.close__panel {
  float: right;
  color: white;
  width: 14px;
  height: 14px;
  margin: 20px 10px 0 0;
  cursor: pointer;
  background: url("../../assets/images/close-delete.svg");
}

.navAllPanel__col {
  width: 280px;
  float: left;
}

.navAllPanel__item {
  padding: 10px 30px;
}

.navAllPanel__title {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  padding-left: 5px;
  border-bottom: 1px solid #383940;
}

.navAllPanel__product {
  position: relative;
  padding-left: 3px;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  width: 100%;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #999999;
  cursor: pointer;
}

.navAllPanel__product:hover {
  background-color: #252932;
}

.select {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 20px;
  width: 24px;
  height: 12px;
}

.product__select {
  background: url("../../assets/images/flag.svg") center no-repeat;
}

.product__selected {
  background: url("../../assets/images/flag-selected.svg") center no-repeat;
}

/*.navAllPanel__product:hover {*/
  /*color: #00a0ff;*/
/*}*/
</style>